import { BREAKPOINTS, Card, COLORS, ContentIcons, GlobalNavigationBar } from '@laerdal/life-react-components';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import posthog from 'posthog-js';
import { useSelector } from 'react-redux';
import { selectMarket } from '../../../store/slices/globalConfigSlice';


const ProgramsContainer = styled.div`

  display: flex;
  
  flex-direction: column;
  align-items: flex-start;
  flex: 1 0 0;
`;
const ProgramsList = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 10px;
`;
const ProgramsTitle = styled.div`
  font-size: 24px;
  font-style: normal;
  font-weight: 600;
  line-height: 28px; 
`;
const ProgramsLink = styled.a`
  &:link, &:visited, &:hover, &:active {
    color: ${COLORS.primary_600};
    text-decoration: none; 
  }

  color: ${COLORS.primary_600};
  font-size: 17px;
  font-style: normal;
  font-weight: 400;
  line-height: 25px; 
`;

const LaerdalPrograms = () => {    
    const navigate = useNavigate()
    const { t } = useTranslation("landingPage");
    const currentMarket = useSelector(selectMarket);
  
    return (
        <ProgramsContainer>
            <ProgramsList>
              <ProgramsTitle>{t('Laerdal Programs')}</ProgramsTitle>
              <ProgramsLink 
                href="https://laerdal.com/services-and-programs/educational-services/"
                onClick={(e) => {
                  e.preventDefault();
                  posthog?.capture('SUPP-LandingPage-ProgramLinkClick', {
                    component: 'LaerdalPrograms',
                    program: 'Educational Services',
                    link: 'https://laerdal.com/services-and-programs/educational-services/'
                  });
                  window.open('https://laerdal.com/services-and-programs/educational-services/', '_blank');
                }}>
                {t('Educational Services with over 160 simulation experts in 22 countries who are ready to help.')}
              </ProgramsLink>
              <ProgramsLink 
                href="https://laerdal.com/services-and-programs/technical-services/"
                onClick={(e) => {
                  e.preventDefault();
                  posthog?.capture('SUPP-LandingPage-ProgramLinkClick', {
                    component: 'LaerdalPrograms',
                    program: 'Technical Services',
                    link: 'https://laerdal.com/services-and-programs/technical-services/'
                  });
                  window.open('https://laerdal.com/services-and-programs/technical-services/', '_blank');
                }}>
                {t('Technical Services  to meet your specific product and training needs.')}
              </ProgramsLink>
              <ProgramsLink 
                href="https://laerdal.com/services-and-programs/managed-services-program/"
                onClick={(e) => {
                  e.preventDefault();
                  posthog?.capture('SUPP-LandingPage-ProgramLinkClick', {
                    component: 'LaerdalPrograms',
                    program: 'Managed Services Program',
                    link: 'https://laerdal.com/services-and-programs/managed-services-program/'
                  });
                  window.open('https://laerdal.com/services-and-programs/managed-services-program/', '_blank');
                }}>
                {t('Managed Services Program for implementing or sustaining an effective simulation training program.')}
              </ProgramsLink>
              { currentMarket !== 'jp' &&
                <ProgramsLink 
                  href="https://laerdal.com/products/courses-learning/virtual-simulation/vsim-for-nursing/"
                  onClick={(e) => {
                    e.preventDefault();
                    posthog?.capture('SUPP-LandingPage-ProgramLinkClick', {
                      component: 'LaerdalPrograms',
                      program: 'Virtual Simulation',
                      link: 'https://laerdal.com/products/courses-learning/virtual-simulation/vsim-for-nursing/'
                    });
                    window.open('https://laerdal.com/products/courses-learning/virtual-simulation/vsim-for-nursing/', '_blank');
                  }}>
                  {t('Virtual Simulation for practice from anywhere with vSim for Nursing.')}
                </ProgramsLink>
              }
              <ProgramsLink
                href="https://laerdal.com/services-and-programs/resuscitation-quality-improvement/"
                onClick={(e) => {
                  e.preventDefault();
                  posthog?.capture('SUPP-LandingPage-ProgramLinkClick', {
                    component: 'LaerdalPrograms',
                    program: 'RQI Program',
                    link: 'https://laerdal.com/services-and-programs/resuscitation-quality-improvement/'
                  });
                  window.open('https://laerdal.com/services-and-programs/resuscitation-quality-improvement/', '_blank');
                }}>
                {t('The Resuscitation Quality Improvement (RQI) programs help meet BLS quality and compliance goals.')}
              </ProgramsLink>
            </ProgramsList>
          </ProgramsContainer>
    );
}

export default LaerdalPrograms;